import { render, staticRenderFns } from "./competitionNav.vue?vue&type=template&id=35787847&scoped=true&lang=html&"
import script from "./competitionNav.vue?vue&type=script&lang=js&"
export * from "./competitionNav.vue?vue&type=script&lang=js&"
import style0 from "./competitionNav.vue?vue&type=style&index=0&id=35787847&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35787847",
  null
  
)

export default component.exports